// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const GiftIconSimple = (props: SVGProps<SVGSVGElement>) => (
	<svg fill="none" xmlns="http://www.w3.org/2000/svg" height="1em" width="1em" viewBox="0 0 70 80" {...props}>
		<defs>
			<linearGradient x1="0%" y1="0%" x2="96.481%" y2="96.481%" id="GiftIconSimple_tsx__a">
				<stop stopColor="#B275F0" offset="0%" />
				<stop stopColor="#F0758A" offset="100%" />
			</linearGradient>
		</defs>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M45.003 18.16c3.433-1.287 8.355-4.652 7.846-8.651-.243-1.918-1.77-3.753-3.795-4.566a6.05 6.05 0 0 0-2.268-.442c-1.617 0-3.274.644-4.827 1.903-3.633 2.944-4.742 9.172-4.961 13.367.014.297.024.582.03.848 1.607-.346 4.198-1.044 7.975-2.46Zm-12.007 1.752c-.174-3.805-1.061-10.352-4.955-13.508-1.553-1.26-3.21-1.903-4.827-1.903-.77 0-1.531.146-2.267.442-2.027.813-3.552 2.648-3.797 4.566-.508 4 4.415 7.364 7.848 8.65 3.776 1.416 6.368 2.114 7.975 2.46.005-.224.012-.46.023-.707Zm36.095 4.75v10.22c0 2.044-1.81 3.709-4.031 3.709H4.94c-2.222 0-4.031-1.665-4.031-3.709v-10.22c0-2.044 1.809-3.709 4.03-3.709h16.487c-4.847-2.444-8.902-6.772-8.243-11.95.428-3.364 2.89-6.415 6.275-7.773C23.092-.23 27.14.525 30.56 3.297c2.063 1.672 3.474 3.945 4.44 6.356.965-2.411 2.377-4.684 4.44-6.356C42.86.523 46.907-.23 50.543 1.23c3.384 1.358 5.847 4.41 6.274 7.774.659 5.177-3.395 9.505-8.243 11.95H65.06c2.222 0 4.03 1.663 4.03 3.709ZM64.273 42.59v32.867c0 2.229-1.806 4.043-4.025 4.043H9.753c-2.22 0-4.025-1.814-4.025-4.043V42.591h58.545Z"
			fill="url(#GiftIconSimple_tsx__a)"
		/>
	</svg>
);
export default GiftIconSimple;
